import { Card } from "@nextui-org/react"
import { Text } from "@nextui-org/react"

import Header from "../header"
import { Box } from "../layout/box"

export default ({header, icon, text, bordered = false, centered = false, dropShadow = false}) => {
    return (
        <>
            <Card
                variant={bordered ? "bordered" : "flat"}
                css={{
                    backgroundColor: "#ffffff",
                    boxShadow: dropShadow ? "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;" : "none"
                }}>
                <Card.Header 
                    css={{
                        display: "flex",
                        // alignItems: "center",
                        // '@smMin': {
                            flexDirection: icon ? "row" : "column",
                            alignItems: (icon || centered) ? "center" : "flex-start"
                        // }
                    }}>
                    {
                        icon &&
                        <Box css={{
                            width: "30px",
                            '@smMin': {
                                width: "33px"
                            }
                        }}>
                            <img src={icon} />
                        </Box>
                    }
                    <Box css={{
                        // '@smMin': {
                        //     mt: "$sm"
                        // }
                    }}>
                        <Header h2 value={header} marginLeft={icon ? "$sm" : 0} />
                    </Box>
                    {/* <Text 
                        color="primary" 
                        css={{
                            ml: "$sm",
                            '@smMin': {
                                ml: 0,
                                mt: "$sm"
                            }
                        }}>{header}</Text> */}
                </Card.Header>
                <Card.Body>
                    <Text 
                        className="font-text"
                        css={{
                        ta: centered ? "center" : "left",
                        // fontFamily: 'Montserrat',
                        // fontWeight: 400,
                        // letterSpacing: "normal"
                    }}>{text}</Text>
                </Card.Body>
            </Card>
        </>
    )
}